import * as _ from 'lodash';
import {
  CREATE_PAYMENT_ITEM_SUCCEEDED,
  FETCH_PAYMENT_DETAIL_SUCCEEDED,
  FETCH_PAYMENT_DETAIL_REQUESTED,
  TOGGLE_PAYMENT_TYPE
} from './pay.actions';
import {GET_COLLECTION_SUCCEEDED} from "../../collection/edit/edit.actions";


export const pay = (state = { initialized: false, data: {}, type: 'full_payment' }, action) => {
  switch (action.type) {
    case FETCH_PAYMENT_DETAIL_REQUESTED:
      return _.assign({}, state, { initialized: false, data: {...action.data} });
    case FETCH_PAYMENT_DETAIL_SUCCEEDED:
      return _.assign({}, state, { initialized: true, data: {...action.data} });
    case CREATE_PAYMENT_ITEM_SUCCEEDED:
      return _.assign({}, state, { initialized: false, data: {}, type: 'full_payment', amount: 0, comments: '' });
    case TOGGLE_PAYMENT_TYPE:
      return _.assign({}, state, {
        type: action.val
      });
    default:
      return state;
  }
};
